import { Onboarding } from '@/onboarding/layout/OnboardingPageTemplate'
import { FrankieOneKycComponent } from './FrankieOneKycComponent'
import type { FrankieOneFlowContext } from '../config/frankieOneFormConfig'

export type PageProps = {
    progress?: number
    token?: string
    isPending?: boolean
    isError?: boolean
    error?: Error | null
    isSuccess?: boolean
    isKYCStart?: boolean
    flowContext?: FrankieOneFlowContext
}

interface ViewModelProps extends PageProps {
    /** Callback when KYC flow completes — *required for production use*; may be omitted in Storybook previews. */
    onComplete?: () => void
    /** Callback when sub-progress changes (0-100%) within KYC step */
    onProgressChange?: (subProgress: number) => void
}

export function KycForm({
    progress = 75,
    token,
    isPending = false,
    isError = false,
    error,
    isSuccess = false,
    isKYCStart = false,
    flowContext,
    onComplete,
    onProgressChange,
}: ViewModelProps) {
    // SDK is active when successfully initialized and KYC has started
    const isSdkActive = isSuccess && isKYCStart

    // Hide submit button when SDK is active (SDK manages its own submission flow)
    const isDisabled = isSdkActive

    // No-op submit handler since SDK manages submission via events
    const handleSubmit = () => {}

    return (
        <Onboarding
            title=""
            description=""
            isLoading={false}
            cta="Next"
            onSubmit={handleSubmit}
            disabled={isDisabled}
            progress={progress}
            hideActions={true}
            modalClassName="px-0 pb-0"
        >
            {flowContext && (
                <FrankieOneKycComponent
                    token={token}
                    isPending={isPending}
                    isError={isError}
                    error={error}
                    isSuccess={isSuccess}
                    isKYCStart={isKYCStart}
                    flowContext={flowContext}
                    onComplete={onComplete}
                    onProgressChange={onProgressChange}
                />
            )}
        </Onboarding>
    )
}
